import React, { createRef, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../../Box';
import { Icon } from '../../Icon';
import { theme } from '../../theme';
import { EmptyResults } from './EmptyResults';
export const SearchOptions = ({ displayedList, selectedValue, highlightedIndex, setHighlightedIndex, onSelect, onKeyDown, positionRelative, resultsBorder, onNotFound, searchTerm, notFoundComponent, }) => {
    const itemRefs = useRef([]);
    useEffect(() => {
        itemRefs.current = displayedList.map((_, i) => itemRefs.current[i] ?? createRef());
    }, [displayedList.length]);
    useEffect(() => {
        const focusedListItem = itemRefs?.current[highlightedIndex]?.current;
        if (highlightedIndex >= 0 && focusedListItem) {
            focusedListItem.scrollIntoView({
                block: 'nearest',
                inline: 'start',
            });
        }
    }, [highlightedIndex]);
    return (React.createElement(BoxWithPositionRelative, null,
        React.createElement(StyledResultsContainer, { "$positionRelative": positionRelative },
            React.createElement(ResultsList, { "$resultsBorder": resultsBorder, onKeyDown: onKeyDown }, displayedList.length ? (displayedList.map((el, i) => {
                const isSelected = selectedValue === el.label || selectedValue === el.value;
                return (React.createElement(ListButton, { key: el.label + '_list_item', "aria-label": el.label + '_list_item', ref: itemRefs.current[i], onClick: () => onSelect(el), "$isSelected": isSelected, "$showBg": highlightedIndex === i, onMouseEnter: () => {
                        setHighlightedIndex(i);
                    }, onFocus: () => {
                        setHighlightedIndex(i);
                    } },
                    el.label,
                    isSelected && (React.createElement(Icon, { render: "tick", size: 16, color: "marshmallowPink" }))));
            })) : (React.createElement(EmptyResults, { onNotFound: onNotFound, searchTerm: searchTerm, notFoundComponent: notFoundComponent }))))));
};
const StyledResultsContainer = styled.div `
  box-sizing: border-box;
  overflow: hidden;
  margin: -16px;
  padding: 16px;
  ${({ $positionRelative }) => !$positionRelative && 'position: absolute;'}
  width:  calc(100% + 32px);
  left: 0px;
  top: -8px;

  ul {
    max-height: 192px;
  }
`;
const ResultsList = styled.ul `
  position: relative;
  list-style: none;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background-color: ${theme.colors.cream};
  border-radius: 12px;
  margin-top: 14px;
  z-index: 1000;
  border: 1px solid ${theme.colors.oatmeal};
  box-shadow:
    0px 10px 18px rgba(18, 18, 23, 0.03),
    0px 5px 8px rgba(18, 18, 23, 0.04),
    0px 2px 4px rgba(18, 18, 23, 0.04);

  li {
    padding: 16px 14px;
    box-sizing: border-box;
    font-size: 16px;
    color: ${theme.colors.liquorice};
    cursor: pointer;
  }
`;
const ListButton = styled.li `
  display: flex;
  justify-content: space-between;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: none;
  }

  ${({ $showBg }) => $showBg &&
    css `
      background-color: ${theme.colors.mascarpone};
    `}

  ${({ $isSelected }) => $isSelected &&
    css `
      background-color: ${theme.colors.custard};
    `}
`;
const BoxWithPositionRelative = styled(Box) `
  position: relative;
`;
//# sourceMappingURL=SearchOptions.js.map